import React, { Component } from "react";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { MultiSelect } from "react-multi-select-component";
import moment from "moment";
import { fetchBranchData } from "../../redux/actions/studentActions";
import {
  InputGroup,
  FormControl,
  Form,
  Col,
  Row,
  Button,
} from "react-bootstrap";
import { default as ReactSelect } from "react-select";
import { pick } from "lodash";
export default class Filters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...this.props.options,
    };
  }

  async componentDidMount() {
    const promises = [];
    if (this.props.hierarchyApiCalls.length > 0) {
      this.props.hierarchyApiCalls.forEach(async (obj) => {
        let promise;
        
          if (obj.UrlName != "") {
            promise = fetchBranchData(obj.UrlName,{});
          }
        promises.push(promise);
      });
    }
    this.props.openLoader();
    try {
      const res = await Promise.all(promises);
      let optionsStateObj = {};
      this.props.hierarchyApiCalls.forEach((obj, index) => {
        this.props.closeLoader();
        const data = res[index];
        optionsStateObj[`${obj.optionsMappingKey}Options`] = data.map(
          (val) => ({
            value: val.id,
            label: val.name,
          })
        );
      });
      this.setState({
        ...optionsStateObj,
      });

      if (this.props.accessChildState) {
        this.props.accessChildState(this.state);
      }
    } catch (error) {
      this.props.closeLoader();
    }
  }
  asyncExecution = (obj, key, index) =>
    new Promise(async (resolve, reject) => {
      let filtersListIndex = this.props.hierarchyLevel.indexOf(key) + 1;
      let categoryDetails = {},
        parentObj = {};
      const url = obj;
      const reqObj = {};
      let preFilterKeysIndex = filtersListIndex + index;
      this.props.filtersList
        .slice(0, preFilterKeysIndex)
        .filter((filterObj) => {
          reqObj[filterObj.mappingKey] = filterObj.state.map(
            (object) => object.label
          );
        });
      this.props.openLoader();
      try {
        const data = await fetchBranchData(url, { ...reqObj });
        let object = {};
        object[`${obj}Options`] = [
          // {
          //     value: 'Select All',
          //     label: 'Select All'
          // }
        ].concat(
          data.map((object) => {
            return { value: object, label: object };
          })
        );
        categoryDetails[`${obj}`] = data.map((object) => {
          return { value: object, label: object };
        });
        if (this.props.isDefaultSelectedAll) {
          parentObj[`${obj}`] = data.map((object) => ({
            value: object,
            label: object,
          }));
        } else {
          if (!this.props.disabledApiCallOnCascade) {
            parentObj[`${obj}`] = [];
          }
        }

        if (Object.keys(parentObj).length > 0) {
          this.updateState(parentObj);
        }
        this.setState(object);
        this.props.closeLoader();
        resolve(true);
      } catch (error) {
        this.props.closeLoader();
      }
    });

  sequentialExecution = (arr, key, index = 0) => {
    if (index >= arr.length) return Promise.resolve();
    return this.asyncExecution(arr[index], key, index).then((r) => {
      return this.sequentialExecution(arr, key, index + 1);
    });
  };

  getFiltersData = async (type, currentStateObj) => {
    let index = this.props.hierarchyLevel.indexOf(type);
    let startIndex = index + 1;
    let endIndex = 1;
    let postHierarchyKeys = this.props.hierarchyLevel.slice(
      startIndex,
      this.props.hierarchyLevel.length
    );
    let preHierarchyKeys = this.props.hierarchyLevel.slice(0, startIndex);
    let stateObj = {},
      optionsObj = {};
    postHierarchyKeys.forEach((obj) => {
      optionsObj[`${obj}Options`] = [];
      stateObj[`${obj}`] = [];
      this.props.filtersList.filter((filterObj) => {
        if (filterObj.mappingKey === obj) {
          if (this.props.disabledApiCallOnCascade) {
            stateObj[`${obj}`] = filterObj.state;
          } else {
            filterObj.state = [];
          }
        }
      });
    });

    let key = this.props.hierarchyLevel[startIndex];
    const url = key;
    const reqObj = {};
    preHierarchyKeys.forEach((obj) => {
      this.props.filtersList.filter((filterObj) => {
        if (filterObj.mappingKey === obj) {
          reqObj[obj] = filterObj.state.map((object) => object.value);
        }
      });
    });
    this.setState({
      ...optionsObj,
    });
    this.updateState({
      ...stateObj,
    });
    if (currentStateObj.length > 0) {
      try {
        this.props.openLoader();
        const temp = await fetchBranchData(url, {
          ...reqObj,
        });
        let object = {},
          parentObj = {};
        // const data = temp.filter((val) => {
        //   return val.length > 0;
        // });
        const data = [...temp]
        object[`${key}Options`] = [].concat(
          data.map((object) => {
            return { value: object.id, label: object.name };
          })
        );
        
        
        this.setState(object);
        this.props.closeLoader();
      } catch (error) {
        this.props.closeLoader();
      }
    }
  };
  updateState = (params) => {
    this.props.updateParentState({
      ...params,
    });
  };
  handleInputChange = async(params, inputObj) => {
  await this.updateState({
    ...params,
  });
  if (inputObj.onMenuCloseApi) {
      this.getFiltersData(inputObj.mappingKey, [params]);
    }
};
  toggleDatePicker() {
    this.component.setOpen(this.focus);
    this.focus = !this.focus;
  }

  handleYearData = (date) => {
    this.props.updateParentState({
      selectedDate: new Date(moment(date).add(0, "years")),
    });
    if (this.props.onDatepickerChange) {
      this.props.onDatepickerChange(date);
    }
  };

  reset() {
    let resetObj = Object.assign({}, this.props.options);
    // delete resetObj[`${this.props.hierarchyLevel[0]}Options`];
    this.props.hierarchyApiCalls.forEach((obj) => {
      delete resetObj[`${obj.optionsMappingKey}Options`];
    });

    this.setState({
      ...resetObj,
    });
    this.props.onReset();
  }

  handleRadioButtonChange = (e) => {
    const { name, value } = e.target;
    this.updateState({
      [name]: value,
    });
  };
  handleEvent =(event, picker)=> {
    this.updateState({
      customRange: {
        startDate: moment(picker.startDate).format("YYYY-MM-DD"),
        endDate: moment(picker.endDate).format("YYYY-MM-DD")
      }
    })
  }
  handleCallback(start, end, label) {
    console.log(start, end, label);
  }

  renderFilters(obj) {
    

    switch (obj.type) {
      case "MultiSelect":
        return (
          <>
          <MultiSelect
            placeholderButtonLabel={obj.placeholder}
            options={this.state[`${obj.mappingKey}Options`]}
            value={obj.state}
            mappingKey={obj.mappingKey}
            onMenuCloseApi={obj.onMenuCloseApi}
            defaultSelectedOptions={obj.defaultSelectedOptions}
            disabled={obj.disabled}
            onChange={(params)=>{
              console.log(params)
                const selectedObj={};
                selectedObj[`${obj.mappingKey}`] = [params];
                this.handleInputChange(selectedObj,obj)
                
            }}
            isMulti={false}
            disabledApiCall={obj.disabledApiCall}
          />
          </>
        );
        break;
        case "Select":
        return (
          <>
            <ReactSelect
              placeholderButtonLabel={obj.placeholder}
              options={this.state[`${obj.mappingKey}Options`]}
              value={obj.state}
              mappingKey={obj.mappingKey}
              onMenuCloseApi={obj.onMenuCloseApi}
              defaultSelectedOptions={obj.defaultSelectedOptions}
              // disabled={obj.disabled}
              onChange={(params)=>{
                  const selectedObj={};
                  selectedObj[`${obj.mappingKey}`] = [params];
                  this.handleInputChange(selectedObj,obj)
                  
              }}
              isDisabled={obj.disabled}
              disabledApiCall={obj.disabledApiCall}
            />
          </>
        );
        break;
        case "TextField":
          return (
            <>
              <Form.Control type="text" placeholder={obj.placeholder}
              value={obj.value}
              onChange={this.handleRadioButtonChange}
              name={obj.mappingKey}
               />
            </>
          );
          break;
      case "DateRangePicker":
        return (
          <div className="filter-datepicker">
            {
              ( moment(obj.state.startDate).format('YYYY') === moment().format("YYYY") ) ?
              (
                <DateRangePicker onEvent={this.handleEvent} onCallback={this.handleCallback}
              initialSettings={
                {
                  startDate : obj.state.startDate,
                  endDate : obj.state.endDate,
                  minDate: obj.state.startDate,
                  maxDate: obj.state.endDate,
                ranges: {
                'Today': [moment(), moment()],
                'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                'This Month': [moment().startOf('month'), moment().endOf('month')],
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'Last Six Months': [moment().subtract(6, 'month').startOf('month'), moment().subtract(6, 'month').endOf('month')]
            }}
          }
            >
              <input type="text" className="form-control" disabled={obj.disabled}/>
            </DateRangePicker>
              ) : (
                <div>
                <DateRangePicker onEvent={this.handleEvent} onCallback={this.handleCallback}
                    initialSettings={
                      {
                        startDate : obj.state.startDate,
                        endDate : obj.state.endDate,
                        minDate: obj.state.startDate,
                        maxDate: obj.state.endDate,
                  }
                }
                  >
              <input type="text" className="form-control" disabled={obj.disabled}/>
            </DateRangePicker>
                </div>
              )
            }
              
          </div>
        );
      case "Radio":
        return (
          <div className="row">
            {obj.keys.map((radioObj) => (
              <div className="col-md-6">
                <label>
                  <input
                    type="radio"
                    value={radioObj.value}
                    checked={obj.state === radioObj.value}
                    onChange={this.handleRadioButtonChange}
                    name={obj.mappingKey}
                  />
                  &nbsp;&nbsp; {radioObj.label}
                </label>
              </div>
            ))}
          </div>
        );
      default:
        return <></>;
    }
  }
  renderView(obj) {
    switch (this.props.viewType) {
      case "verticle":
        return (
          <Form className="dropdown-labels">
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Label>
                <b>
                  {obj.required ? (
                    <>
                      <span className="text-danger">*</span> {obj.label}
                    </>
                  ) : (
                    obj.label
                  )}{" "}
                </b>
              </Form.Label>
              {this.renderFilters(obj)}
            </Form.Group>
          </Form>
        );
        break;
      case "inline":
        return (
          <Form>
            <Form.Group as={Row} controlId="formPlaintextEmail">
              <Form.Label column sm="4">
                <b>{obj.label}</b>
              </Form.Label>
              <Col sm="8">{this.renderFilters(obj)}</Col>
            </Form.Group>
          </Form>
        );
        break;
      case "horizontal":
        return (
          <Form>
            <Form.Group as={Row} controlId="formPlaintextEmail">
              <Form.Label column sm="4">
                {obj.label}
              </Form.Label>
              <Col sm="8">{this.renderFilters(obj)}</Col>
            </Form.Group>
          </Form>
        );
        break;

      default:
        return <>{this.renderFilters(obj)}</>;
        break;
    }
  }

  renderFilterButtons() {
    switch (this.props.viewType) {
      case "verticle":
        return (
          <>
            <div className="col-12">
              <Form.Group controlId="exampleForm.ControlInput1">
                <Form.Label>
                  <br />
                </Form.Label>
                <div className="row">
                  <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                    <Button
                      className="btn  app-default-button"
                      onClick={() => this.props.filterData()}
                      disabled={this.props.isFilterButtonDisabled}
                    >
                      <i className="fa fa-filter"></i> &nbsp;Filter
                    </Button>
                  </div>
                  <div className="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-6">
                    <button
                      className="btn btn-primary resetButton"
                      onClick={() => this.reset()}
                      disabled={this.props.isResetButtonDisabled}
                    >
                      <span>
                        <i className="fa fa-repeat"></i>&nbsp; Reset
                      </span>
                    </button>
                  </div>
                </div>
              </Form.Group>
            </div>
          </>
        );

        break;
      default:
        return (
          <>
            <div className="col-xs-12 col-sm-6 col-md-5 col-lg-5 col-xl-5">
              <button
                className="btn btn-primary filterBtn"
                onClick={() => this.props.filterData()}
                disabled={this.props.isFilterButtonDisabled}
              >
                <span>
                  <i className="fa fa-filter" />
                  &nbsp; Filter
                </span>
              </button>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-5 col-lg-5 col-xl-5">
              <button
                className="btn btn-primary resetButton"
                onClick={() => this.reset()}
                disabled={this.props.isResetButtonDisabled}
              >
                <span>
                  <i className="fa fa-repeat"></i>&nbsp; Reset
                </span>
              </button>
            </div>
          </>
        );
        break;
    }
  }
  render() {
    return (
      <React.Fragment>
        {/* {<div className='col-md-12'>
          <div className='row'>
            {this.props.filtersList.map((obj, index) => (
              <div key={index} className="col-2">
                {this.renderView(obj)}
              </div>
            ))}
            <div className='col-md-3'>
              {this.props.isFilterButtonRequired ? this.renderFilterButtons() : null}
            </div>
          </div>
        </div>} */}
        <div className="col-md-10">
          <div className="row">
            {this.props.filtersList.map((obj, index) => (
              <div key={index} className={obj.grid}>
                {this.renderView(obj)}
              </div>
            ))}
          </div>
        </div>
        <div className="col-md-2">
          <div className="row">
            {this.props.isFilterButtonRequired
              ? this.renderFilterButtons()
              : null}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

Filters.defaultProps = {
  isDefaultSelectedAll: true,
  isFilterButtonRequired: true,
};
